module.exports = __webpack_public_path__ + "img/somalia.c356806.webp";